export const availableFilters = {
    type: [
        {
            label: 'License',
            value: 'License',
            checked: false
        }, {
            label: 'Vulnerability',
            value: 'Dep. Vulnerability',
            checked: false
        }
    ],
    risk_score: [
        {
            label: 'Critical',
            value: 'critical',
            checked: false
        }, {
            label: 'High',
            value: 'high',
            checked: false
        }, {
            label: 'Moderate',
            value: 'moderate',
            checked: false
        }, {
            label: 'Low',
            value: 'low',
            checked: false
        }, {
            label: 'Nominal',
            value: 'nominal',
            checked: false
        }
    ],
    status: [
        {
            label: 'Unassigned',
            value: 'New',
            checked: false
        }, {
            label: 'Assigned',
            value: 'High',
            checked: false
        }, {
            label: 'Resolved',
            value: 'resolved',
            checked: false
        }, {
            label: 'Archived',
            value: 'archived',
            checked: false
        }
    ],
    scan_type: [
        {
            label: 'Codebase Scan',
            value: 'Codebase',
            checked: false
        }, {
            label: 'Machine Scan',
            value: 'Machine',
            checked: false
        }, {
            label: 'System Scan',
            value: 'System',
            checked: false
        },
    ],
    stage: [
        {
            label: 'Development',
            value: 'development',
            checked: false
        }, {
            label: 'CI/CD',
            value: 'cicd',
            checked: false
        }, {
            label: 'Production',
            value: 'production',
            checked: false
        },
    ],
    findings: [
        {
            label: 'Has Critical',
            value: 'critical',
            checked: false
        }, {
            label: 'Has High',
            value: 'high',
            checked: false
        }, {
            label: 'Has Low',
            value: 'low',
            checked: false
        }, {
            label: 'Has Moderate',
            value: 'moderate',
            checked: false
        }, {
            label: 'Has Nominal',
            value: 'nominal',
            checked: false
        },
    ],
    date: [
        {
            label: 'Past hour',
            value: 'Past hour',
            from: new Date(Date.now() - 3600 * 1000).setMilliseconds(0), // 1 hour ago
            to: new Date().setMilliseconds(0),
            checked: false
        },
        {
            label: 'Past 24 hours',
            value: 'Past 24 hours',
            from: new Date(Date.now() - 86400 * 1000).setMilliseconds(0),
            to: new Date().setMilliseconds(0),
            checked: false
        }, {
            label: 'Past 7 days',
            value: 'Past 7 days',
            from: new Date(Date.now() - 7 * 86400 * 1000).setMilliseconds(0),
            to: new Date().setMilliseconds(0),
            checked: false
        }, {
            label: 'Past 30 days',
            value: 'Past 30 days',
            from: new Date(Date.now() - 30 * 86400 * 1000).setMilliseconds(0),
            to: new Date().setMilliseconds(0),
            checked: true
        }, {
            label: 'Select from calendar',
            value: 'Custom Range',
            from: undefined,
            to: undefined,
            checked: false
        }
    ],
    ecosystems: [
        {
            label: 'Pypi',
            value: 'PyPi',
            checked: false,
        }, {
            label: 'NPM',
            value: 'npm',
            checked: false,
        },
    ]
}

export const storeFilterData = {
    findingsTableFilters: {
        table: 'Findings',
        filters: [
            { title: 'Codebase', col: 'project', type: 'Common' },
            { title: 'Status', col: 'status', type: 'Common' }
        ]
    },
    projectFindingsTableFilters: {
        table: 'Findings',
        filters: [
            { title: 'Status', col: 'status', type: 'Common' }
        ]
    },
    codebaseFindingsTableFilters: {
        table: 'Findings',
        filters: [
            { title: 'Status', col: 'status', type: 'Common' }
        ]
    },
    scansTableFilters: {
        table: 'Scans',
        filters: [
            { title: 'Date Range', col: 'date', type: 'Date Range' },
            { title: 'Codebase', col: 'project', type: 'Common' },
            { title: 'Stage', col: 'stage', type: 'Common' },
            { title: 'Findings', col: 'findings', type: 'Common' },
            { title: 'Branch', col: 'branch_name', type: 'Common' },
        ]
    },
    packagesTableFilters: {
        table: 'Codebase Packages',
        filters: [
            { title: 'Language', col: 'ecosystems', type: 'Common' },
        ],
    },
    codebaseScansTableFilters: {
        table: 'Codebase Scans',
        filters: [
            { title: 'Date Range', col: 'date', type: 'Date Range' },
            { title: 'Stage', col: 'stage', type: 'Common' },
            { title: 'Findings', col: 'findings', type: 'Common' }
        ]
    }
}
